import { z } from '@bonanza-social/toolkit/api';

export const PrizeWallImageSetSchema = z.object({
  desktopUrl: z.string(),
  mobileUrl: z.string(),
});

export const PrizeWallStateSchema = z.enum([
  'NotStarted',
  'Pending',
  'Open',
  'Finished',
]);

export const PrizeWallPrizeTierSchema = z.enum(['Low', 'Medium', 'High']);

export const PrizeWallPrizeTypeSchema = z.enum(['Physical', 'Coins', 'Cash']);

export const PrizeWallImagesSchema = z.object({
  promotionalIcon: PrizeWallImageSetSchema,
  promotionalImage: PrizeWallImageSetSchema,
  promotionalBackgroundImage: PrizeWallImageSetSchema,
  infoBannerImage: PrizeWallImageSetSchema,
  infoBackgroundImage: PrizeWallImageSetSchema,
  quickRulesBackgroundImage: PrizeWallImageSetSchema,
  ribbonImage: PrizeWallImageSetSchema,
  winnersBackgroundImage: PrizeWallImageSetSchema,
  tokenIconSmall: PrizeWallImageSetSchema,
  tokenIconLarge: PrizeWallImageSetSchema,
});

export const PrizeWallCampaignSchema = z.object({
  id: z.number(),
  name: z.string(),
  images: PrizeWallImagesSchema,
  startDate: z.string(),
  endDate: z.string(),
  tokenName: z.string(),
  tokenBalance: z.number(),
  termsAndConditions: z.string(),
});

export const PrizeWallPrizeSchema = z.object({
  rewardId: z.string(),
  name: z.string(),
  imageUrl: z.string(),
  description: z.string(),
  totalQuantity: z.number(),
  remainingQuantity: z.number(),
  tier: PrizeWallPrizeTierSchema,
  type: PrizeWallPrizeTypeSchema,
});

export const PrizeWallQuickRuleSchema = z.object({
  title: z.string(),
  image: PrizeWallImageSetSchema,
});

export const PrizeWallWinnerSchema = z.object({
  username: z.string(),
  rewardId: PrizeWallPrizeSchema.shape.rewardId,
});

export const PrizeWallSchema = z.object({
  id: z.number(),
  costOfPlay: z.number(),
  winProbability: z.number(),
  tokenCampaignId: z.number(),
  state: PrizeWallStateSchema,
  rewards: z.array(PrizeWallPrizeSchema),
  headerImage: PrizeWallImageSetSchema,
  backgroundImage: PrizeWallImageSetSchema,
  openDate: z.string(),
  quickRules: z.array(PrizeWallQuickRuleSchema),
  winners: z.array(PrizeWallWinnerSchema),
});

export const PrizeWallRewardSchema = z.object({
  isWin: z.boolean(),
  tokenBalance: z.number(),
  rewardId: PrizeWallPrizeSchema.shape.rewardId.optional(),
});

export const PrizeWallWinnersSchema = z.object({
  winners: z.array(PrizeWallWinnerSchema),
  nextWallStartDate: z.string().optional(),
});
